import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
	LinkedinShareButton,
} from 'react-share';

export const socialNetworks = {
  facebook: FacebookShareButton,
  twitter: TwitterShareButton,
  whatsapp: WhatsappShareButton,
  mail: EmailShareButton,
	linkedin: LinkedinShareButton,
};
